import { useEffect, useState } from "react";
import { countries } from "../../global/countriesAndSources";
import { addIgo, createIgoTheme, getIgoThemes, setIgoLogo } from "../../HTTP/countries";

export default function AddIgoTheme() {

  const localUser = JSON.parse(localStorage.getItem("user"))
    if (!localUser.super_admin && localUser.admin_access !== 5) {
        window.location.href = '/'
    }

    const [formData, setFormData] = useState({
        name: '',
    });


    // Fonction pour formater le texte (minuscules et tirets au lieu d'espaces)
    const formatText = (text) => {
        return text.toLowerCase().replace(/\s+/g, '-');
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        
        // Mettre à jour le champ modifié
        const updatedFormData = {
            ...formData,
            [name]: type === 'checkbox' ? checked : value
        };
        
        // Si c'est le champ label qui est modifié, on vérifie si le nom correspond au format du label
        // Si oui, on continue à mettre à jour le nom automatiquement
        if (name === 'label') {
            const formattedLabel = formatText(value);
            // On vérifie si le champ nom est vide OU s'il correspond au format du label précédent
            // Si c'est le cas, on continue à mettre à jour automatiquement le champ nom
            if (formData.name === '' || formData.name === formatText(formData.label)) {
                updatedFormData.name = formattedLabel;
            }
        }
        
        setFormData(updatedFormData);
        console.log(updatedFormData);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            // Mise à jour des données sans l'image
            const formwithoutImage = {
                name: formData.name,
            };
            
            const res = await createIgoTheme(formwithoutImage.name);
            console.log("res", res);
            
            // Vérifier si res est vraiment un succès (selon votre API)
            if (res) {
                    alert('Igo theme added successfully');
                window.location.href = "/admin/igo-theme";
            } else {
                alert("Error adding Igo theme");
            }
        } catch (error) {
            console.error("Error adding Igo theme:", error);
            alert("Error adding Igo theme");
        }
    };

    return (
        <div className="mt-8 max-w-md mx-auto p-6 bg-white rounded-lg shadow-md md:overflow-y-auto" style={{ maxHeight: window.innerWidth >= 768 ? 'calc(100vh - 100px)' : undefined }}>
            <h2 className="text-2xl font-bold mb-6 text-center">Ajouter une organisation</h2>
            <form onSubmit={handleSubmit}>
                <div className="mb-4">
                    <label htmlFor="name" className="block text-gray-700 text-sm font-bold mb-2">
                        Nom :
                    </label>
                    <input
                        type="text"
                        name="name"
                        id="name"
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        onChange={handleChange}
                        value={formData.name}
                        required
                    />
                </div>
                <div className="flex items-center justify-end">
                    <button
                        type="submit"
                        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                    >
                        Enregistrer
                    </button>
                </div>
            </form>
        </div>
    );
}